import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

interface ISearchContextData {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
}

interface IProps {
  children: ReactNode
}

const SearchContext = createContext<ISearchContextData>(
  {} as ISearchContextData,
)

const SearchProvider = ({ children }: IProps) => {
  const [searchTerm, setSearchTerm] = useState('')

  const value = useMemo(
    () => ({
      searchTerm,
      setSearchTerm,
    }),
    [searchTerm],
  )

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  )
}

const useSearch = () => {
  const context = useContext(SearchContext)

  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider')
  }

  return context
}

export { SearchProvider, useSearch }
